import LinkButtonCellRenderer from './ItemsInProgress/LinkButtonCellRenderer';
import StatusButtonCellRenderer from './ItemsInProgress/StatusButtonCellRenderer';

export const inProgressColumnDefs = [
  {
    field: 'legalEntityName',
    headerName: 'Entity Name',
    cellRenderer: 'agGroupCellRenderer',
    suppressHeaderMenuButton: true,
  },

  {
    field: 'submittedDate',
    headerName: 'Submitted Date',
    suppressHeaderMenuButton: true,
  },
  {
    field: 'type',
    headerName: 'Category',
    suppressHeaderMenuButton: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    cellRenderer: 'statusCellRenderer',
    suppressHeaderMenuButton: true,
  },
  {
    field: 'total',
    headerName: 'No. of Accounts',
    suppressHeaderMenuButton: true,
  },

  {
    field: 'viewDetails',
    headerName: '',
    cellRenderer: 'detailCellRenderer',
    suppressHeaderMenuButton: true,
  },
];

const components = {
  detailCellRenderer: LinkButtonCellRenderer,
  statusCellRenderer: StatusButtonCellRenderer,
};

export const inProgressDetailCellRendererParams = {
  detailGridOptions: {
    suppressContextMenu: true,
    components: components,
    columnDefs: [
      {
        field: 'accountName',
        headerName: 'Account Name',
        suppressHeaderMenuButton: true
      },
      {
        field: 'submittedDate',
        headerName: 'Submitted Date',
        suppressHeaderMenuButton: true
      },
      {
        field: 'accountType',
        headerName: 'Account Type',
        suppressHeaderMenuButton: true
      },
      {
        field: 'status',
        headerName: 'Status',
        cellRenderer: 'statusCellRenderer',
        suppressHeaderMenuButton: true
      },
      {
        field: 'viewDetails',
        headerName: '',
        cellRenderer: 'detailCellRenderer',
        suppressHeaderMenuButton: true
      },
    ],
    defaultColDef: {
      flex: 1,
    },
  },
  getDetailRowData: (params: any) => {
    params.successCallback(params.data.children);
  },
};
